module.exports = __webpack_public_path__ + "static/media/exit.f1300b63.svg";